import { COUNTRY, CURRENCY } from '@/types/api/common';
import { BRAND, Brand } from '@/types/brand';

export const getCurrency = (brand: Brand) => {
  if (brand === BRAND.SE_ENEAS || brand === BRAND.SE_NORDEL) return CURRENCY.SEK;
  if (brand === BRAND.FI_VENI || brand === BRAND.DE_VENI) return CURRENCY.EUR;

  return CURRENCY.NOK;
};

export const getCountry = (brand: Brand) => {
  if (brand === BRAND.SE_ENEAS || brand === BRAND.SE_NORDEL) return COUNTRY.SWEDEN;
  if (brand === BRAND.FI_VENI) return COUNTRY.FINLAND;
  if (brand === BRAND.DE_VENI) return COUNTRY.GERMANY;

  return COUNTRY.NORWAY;
};
